"use client";

import React, { createContext, useContext, useMemo } from "react";
import { GrpcUnifiedInterceptor } from "./GrpcAuthInterceptor";
import { ManagementServiceClient } from '@/app/proto/ManagementServiceClientPb';

interface GrpcContextType {
	myServiceClient: ManagementServiceClient;
}

const GrpcContext = createContext<GrpcContextType | null>(null);

export const GrpcProvider = ({ children }: { children: React.ReactNode }) => {
	const contextValue = useMemo(() => {
		const unifiedInterceptor = new GrpcUnifiedInterceptor();

		const clientOptions = {
			unaryInterceptors: [unifiedInterceptor],
			streamInterceptors: [unifiedInterceptor]
		};

		const myServiceClient = new ManagementServiceClient(
			process.env.NEXT_PUBLIC_GRPC_URL || "https://api.auctionboost.app",
			null,
			clientOptions
		);

		return { myServiceClient };
	}, []);

	return (
		<GrpcContext.Provider value={contextValue}>
			{children}
		</GrpcContext.Provider>
	);
};

export const useGrpcClient = () => {
	const context = useContext(GrpcContext);
	if (!context) throw new Error("useGrpcClient must be used within GrpcProvider");
	return context.myServiceClient;
};




